import { useEffect, useRef, useState } from "react"
import { validateEmail } from "../../utils/util";
import Loading from '../../components/Loading';
import { Login, setuserData } from "../../actions/actions";
import { useCookies } from "react-cookie";
import { COOKIESPREFIX } from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { adminLoginWithPassword } from "../../services/users";
import Logo from '../../svgs/TgatherLogoSvg';

function Screen(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [cookies, setCookie, removeCookie] = useCookies([`${COOKIESPREFIX}_cred`, `${COOKIESPREFIX}_token`]);

    const [email, setEmail] = useState('');
    const [isloading, setisloading] = useState(false);
    const handleEmailInput = (e) => { setEmail(e.target.value) };
    const [password, setPassword] = useState('');
    const handlePasswordInput = (e) => { setPassword(e.target.value) };

    const handleLogin = async () => {
        if (!validateEmail(email)) {
            alert('Invalid Email'); return
        }
        if (!password) {
            alert('Invalid'); return
        }
        try {
            let res = await adminLoginWithPassword(email, password)
            if (res.errno) {
                alert(res.message || 'Invalid');
                return
            }

            let token = res?.token?.token
            let userId = res?.token?.userId
            props.dispatch(Login(true, token, res.token.type, email, userId))

            setCookie(`${COOKIESPREFIX}_cred`, { email: email, usertype: res.token.type }, { path: '/' });
            setCookie(`${COOKIESPREFIX}_token`, token, { path: '/', expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7) }); //7 days

        } catch (e) {
            alert(e.message)
        } finally {
            setisloading(false)
        }
    }
    useEffect(() => {
        if (props?.token?.usertype && props?.token?.usertype !== 'merchant') {
            props.dispatch(Login(false))
        }
    }, [props.token])

    const handlePressEnter = (e) => {
        if (e.key === 'Enter') {
            handleLogin()
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden">
            <div className='w-full h-[105px] flex items-center justify-center' style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }}>
                <Logo />
            </div>
            <div className="flex flex-col w-full flex-1 items-center justify-center">
                <div className="relative max-w-[400px] w-full border-white border-2 d-pad-24-m-16 rounded-[24px] flex flex-col justify-center items-center overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1, }} />
                    <div className="text-[#6E604C] font-[700] text-[24px]">管理員登入</div>
                    <div className="font-bold mt-[24px] w-full text-left text-[#6E604C] z-[2">電郵地址</div>
                    <div className='w-full mt-[4px] z-[2]' style={{ borderBottom: '1px solid black', padding: '8px 12px' }}>
                        <input value={email} onChange={handleEmailInput} name='email' className='w-full' style={{ border: 'none', background: "transparent" }} placeholder='請輸入電郵地址' />
                    </div>
                    <div className="font-bold mt-[24px] w-full text-left text-[#6E604C] z-[2">密碼</div>
                    <div className='w-full mt-[4px] z-[2]' style={{ borderBottom: '1px solid black', padding: '8px 12px' }}>
                        <input value={password} onChange={handlePasswordInput} type='password' name='password' className='w-full' style={{ border: 'none', background: "transparent" }} placeholder='請填寫密碼' onKeyDown={handlePressEnter} />
                    </div>
                    <div onClick={handleLogin} className="w-[100%] min-h-[50px] cursor-pointer z-[2] flex justify-center items-center text-white text-[16px] font-[700] rounded-[99px] mt-[64px] mb-[24px]" style={{ background: 'linear-gradient(180deg, #8C866B 0%, rgba(143, 137, 109, 0.96) 14%, rgba(153, 146, 116, 0.84) 32%, rgba(169, 160, 127, 0.8) 53%, rgba(153, 146, 116, 0.4) 100%)', border: '1px solid #8F896DF5' }}>
                        登入
                    </div>
                </div>
            </div>
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Screen)